import { render } from "./LdapConfigForm.vue?vue&type=template&id=0f7d8dc7&ts=true"
import script from "./LdapConfigForm.vue?vue&type=script&lang=ts"
export * from "./LdapConfigForm.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__